export const BEFORE_LOGOUT_EVENT = 'teaches:before-logout';

// 主動登出先交給目前頁面的離頁確認；系統強制登出仍直接 dispatch logoutCall。
export const requestLogout = (logout: () => void): void => {
	if (typeof window !== 'undefined') {
		const event = new CustomEvent(BEFORE_LOGOUT_EVENT, { cancelable: true, detail: logout });
		if (!window.dispatchEvent(event)) return;
	}
	logout();
};
